"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenTableau = void 0;
function OpenTableau(workbookInfo) {
    var tableauProtocol = 'tableau:';
    var tableauUrl = new URL(tableauProtocol);
    tableauUrl.searchParams.append('workbook-luid', workbookInfo.workbookLuid);
    tableauUrl.searchParams.append('server-host', workbookInfo.serverHost);
    tableauUrl.searchParams.append('server-site-name', workbookInfo.site);
    window.open(tableauUrl.href, '_self');
}
exports.OpenTableau = OpenTableau;
//# sourceMappingURL=ProtocolHelper.js.map